//! @ngInject
export function patientLookupService($rootScope, $q, DatabaseApi) {
  /**
   * Resolves patients by id, one small request at a time.
   *
   * The counterpart of caregiverLookupService. A page holding a patient id and
   * needing a name used to read `DatabaseApi.patients()[id]`, which only worked
   * once every patient in the agency had been downloaded. The search index
   * answers the same question with an exact `ids` filter.
   */
  const cache = new Map();

  function searchUrl() {
    return (
      "agencies/" +
      $rootScope.agencyId +
      "/agency_members/" +
      $rootScope.agencyMemberId +
      "/search/patients"
    );
  }

  function byIds(ids) {
    const wanted = [...new Set(ids.filter((id) => id !== null && id !== undefined))];
    const missing = wanted.filter((id) => !cache.has(String(id)));

    if (missing.length === 0) {
      return $q.resolve(new Map(wanted.map((id) => [String(id), cache.get(String(id))])));
    }

    const url = searchUrl() + "?ids=" + missing.join(",") + "&limit=" + missing.length;

    return DatabaseApi.get(url).then(function (res) {
      const items = res && res.data ? res.data.items || [] : [];
      items.forEach(function (item) {
        cache.set(String(item.id), item);
      });
      return new Map(
        wanted
          .filter((id) => cache.has(String(id)))
          .map((id) => [String(id), cache.get(String(id))])
      );
    });
  }

  /**
   * Structured addresses by id.
   *
   * `DatabaseApi.fillPatientsAddress` did this by writing the result back into
   * the patient dictionary, which is one of the things that kept the dictionary
   * alive - a caller could not have the addresses without first having every
   * patient. The endpoint already takes ids, so it can just answer with them.
   */
  function addressesByIds(ids) {
    const wanted = [...new Set(ids.filter((id) => id !== null && id !== undefined))];

    if (wanted.length === 0) {
      return $q.resolve(new Map());
    }

    const url =
      "agencies/" +
      $rootScope.agencyId +
      "/agency_members/" +
      $rootScope.agencyMemberId +
      "/patient_addresses";

    return DatabaseApi.post(url, { ids: wanted }).then(function (res) {
      const rows = res && res.data ? res.data.addresses || [] : [];
      return new Map(rows.map((row) => [String(row.patientId), row.address]));
    });
  }

  return {
    byIds: byIds,
    addressesByIds: addressesByIds,

    /** Resolves to the patient, or null when the id matches nobody. */
    byId: function (id) {
      return byIds([id]).then(function (map) {
        const found = map.get(String(id));
        return found === undefined ? null : found;
      });
    }
  };
}
